import QueryLoaderWrapper from "./QueryLoaderWrapper";
import * as Skeletons from "./skeletons";

export {
    QueryLoaderWrapper,
    Skeletons
};
